import { I18N_CONFIG } from './config'

export function getStoredLanguage(): string | null {
  if (typeof window === 'undefined') return null
  
  // 优先检查新的统一键
  const newKey = localStorage.getItem(I18N_CONFIG.localStorageKey)
  if (newKey) return newKey
  
  // 向后兼容：检查旧键并迁移
  const oldKey1 = localStorage.getItem('i18nextLng')
  const oldKey2 = localStorage.getItem('language')
  const oldValue = oldKey1 || oldKey2
  
  if (oldValue) {
    // 迁移到新键
    setStoredLanguage(oldValue)
    // 清理旧键
    localStorage.removeItem('i18nextLng')
    localStorage.removeItem('language')
    return oldValue
  }
  
  return null
}

export function setStoredLanguage(language: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(I18N_CONFIG.localStorageKey, language)
}

export function clearStoredLanguage(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(I18N_CONFIG.localStorageKey)
  // 清理旧键
  localStorage.removeItem('i18nextLng')
  localStorage.removeItem('language')
}

export function getBrowserLanguage(): string {
  if (typeof window === 'undefined') return I18N_CONFIG.defaultLanguage
  
  const browserLang = navigator.language.toLowerCase()
  
  // 映射浏览器语言到支持的语言
  if (browserLang.startsWith('zh')) {
    if (browserLang.includes('tw') || browserLang.includes('hk') || browserLang.includes('hant')) {
      return 'zh-TW'
    }
    if (browserLang.includes('cn') || browserLang.includes('hans')) {
      return 'zh-CN'
    }
    // 其他中文变体默认使用繁体（根据需求）
    return 'zh-TW'
  }
  if (browserLang.startsWith('en')) return 'en'
  
  return I18N_CONFIG.defaultLanguage
}

export function isValidLanguage(language: string): language is typeof I18N_CONFIG.supportedLanguages[number] {
  return I18N_CONFIG.supportedLanguages.includes(language as typeof I18N_CONFIG.supportedLanguages[number])
}